import React from "react";
import SvgLink from '../SVG';
import {FONTELLO_FONTAWESOME_STAR, FONTELLO_FONTAWESOME_STAR_EMPTY, FONTELLO_FONTAWESOME_STAR_HALF_ALT} from '../SVG/consts';

const ReviewRating = ({averageRating, reviewCount}) => (
    <div className="review-rating">
        <div className="review-stars">
            {[...Array(5).keys()].map((key) => (
                averageRating > key ? averageRating >= key+1 ? <SvgLink key={key} {...FONTELLO_FONTAWESOME_STAR} /> : <SvgLink key={key} {...FONTELLO_FONTAWESOME_STAR_HALF_ALT} /> : <SvgLink key={key} {...FONTELLO_FONTAWESOME_STAR_EMPTY} />
            ))}
        </div>
        <span className="review-count">{reviewCount} Reviews</span>
    </div>
);

export default ReviewRating;